import { Injectable } from '@angular/core'
import { RegionalApiClientSetupService } from '@ftr/api-regional'
import { Uuid } from '@ftr/contracts/type/shared'
import { ApiResult } from '@ftr/foundation'
import { ManageRecordingStatus } from '@ftr/regional-api-contracts'
import { switchMap } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class ManageCourtroomRecordingService extends RegionalApiClientSetupService {
  override regionalApiPath = 'live-stream/recording'

  getRecordingStatus(courtSystemId: Uuid, locationId: Uuid): ApiResult<ManageRecordingStatus | undefined> {
    return this.regionalApiClient(this.regionalApiPath, courtSystemId).pipe(
      switchMap(client =>
        client.get<ManageRecordingStatus | undefined>({
          headers: { courtSystemId },
          path: `/location/${locationId}/manage-status`,
          responseBodyType: ManageRecordingStatus,
        }),
      ),
    )
  }
}
